import React from 'react';
import styles from './UnAuthMain.styles.scss';

import { Header } from '../../components/Header';
import cn from 'classnames';

const UnAuthMain = ({ t }) => {
  return (
    <div className={cn(styles.layout)}>
      <Header />
      <div className={cn(styles.inner)}>
        <h1>Welcome to NBR E-Invoicing Portal </h1>
      </div>
    </div>
  );
};

export default React.memo(UnAuthMain);
